<template>
  <div class="popup-back" :class="{ opened: opened }" @click="close">
    <span class="helper"></span>
    <div class="popup" @click.stop="noop">
      <div class="popup-content">
        <div class="logo-wrapper">
          <img src="../assets/hound.png" alt="" />
        </div>
        <div class="title-wrapper">
          <div class="title">Driphound is better if you're logged in</div>
        </div>
        <div class="message-wrapper">
          <div class="message">
            Like your favorite products. Follow artists' shops. Get
            notifications for new drops.
          </div>
        </div>
        <div class="spotify-login">
          <a :href="spotifyLink">
            <button type="button" class="spotify-btn">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.873 13.298c-4.835-2.872-12.81-3.136-17.426-1.735a1.403 1.403 0 1
                    1-.815-2.685c5.299-1.608 14.107-1.297 19.673 2.007a1.403 1.403 0 0 1-1.432
                    2.413zm-.158 4.253a1.17 1.17 0 0
                    1-1.609.385c-4.031-2.478-10.178-3.196-14.947-1.748a1.171 1.171 0 0 1-1.46-.78
                    1.171 1.171 0 0 1 .78-1.458c5.448-1.653 12.221-.852 16.85 1.993a1.17 1.17 0 0 1
                    .386 1.608zm-1.836 4.084a.934.934 0 0
                    1-1.285.311c-3.523-2.152-7.956-2.639-13.178-1.446A.935.935 0 1 1 7
                    18.678c5.714-1.306 10.615-.744 14.569 1.672.44.269.58.845.31 1.285zM0 15c0 8.285
                    6.716 15 15 15 8.284 0 15-6.715 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0
                    15z"
                  fill="#FFFFFE"
                  fill-rule="evenodd"
                ></path>
              </svg>
              Continue with Spotify
            </button>
          </a>
        </div>
        <div class="or-wrapper">
          <div class="or">
            <div class="line"></div>
            <div class="or-text">or</div>
            <div class="line"></div>
          </div>
        </div>
        <div class="email-login">
          <span class="login-text">
            <span class="login">
              <a href="/login"> Log In </a>
            </span>
            or
            <span class="signup">
              <a href="/signup"> Sign Up</a>
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus, EventBusEvents } from "../event-bus";

export default {
  name: "SignupPleaseModal",
  data() {
    return {
      opened: false,
    };
  },
  created() {
    const that = this;
    EventBus.$on(EventBusEvents.OpenSignupPleaseModal, function () {
      that.open();
    });
  },
  computed: {
    spotifyLink() {
      return `${process.env.VUE_APP_API_URL}/v1/auth/spotify`;
    },
  },
  methods: {
    open() {
      this.opened = true;
    },
    close() {
      this.opened = false;
    },
    noop() {},
  },
};
</script>

<style lang="scss" scoped>
.popup-back {
  background: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  display: none;
  height: 100%;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 10000;
  &.opened {
    display: block;
  }
  .helper {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  .popup {
    color: black;
    background-color: #fff;
    box-shadow: 10px 10px 60px #555;
    display: inline-block;
    height: auto;
    max-width: 551px;
    min-height: 100px;
    vertical-align: middle;
    width: 92%;
    position: relative;
    border-radius: 8px;
    text-align: left;
    padding: 15px 5%;
    @media (min-width: 786px) {
      width: 60%;
    }
    .popup-content {
      padding: 8px;
    }
  }
}

.logo-wrapper {
  text-align: center;
  img {
    width: 75%;
    margin-bottom: 12px;
  }
}
.title-wrapper {
  margin-top: 8px;
  margin-bottom: 12px;
  .title {
    text-align: center;
    display: block;
    color: #181818;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin: -6px 0 -6px;
  }
}
.message-wrapper {
  margin-bottom: 20px;
  .message {
    text-align: center;
    display: block;
    color: #8e8e8e;
    font-weight: 400;
  }
}
.spotify-login {
  margin-bottom: 8px;
  flex: 0 0 auto;
  justify-content: flex-start;
  align-items: stretch;
  a {
    width: 100%;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
    button {
      width: 100%;
      border: 0;
      background-color: #1db954 !important;
      color: #fafafa !important;
      position: relative;
      text-align: center;
      font-family: Roboto, sans-serif;
      border-radius: 8px;
      appearance: none;
      background: 0 0;
      box-sizing: border-box;
      cursor: pointer;
      display: block;
      font-weight: 600;
      padding: 15px 9px;
      padding-left: 25px;
      text-transform: inherit;
      text-overflow: ellipsis;
      user-select: none;
      font-size: 12px;
      line-height: 18px;
      margin: 0;
      opacity: 1;
      margin: 16px 0;
      margin-bottom: 10px;
      border-radius: 500px;
      letter-spacing: 1px;
      min-width: 160px;
      text-transform: uppercase;
      white-space: normal;
      font-weight: 700;
      text-decoration: none;

      &:hover {
        opacity: 0.9;
      }
      &:disabled {
        opacity: 0.5;
      }
      svg {
        width: 18px;
        height: 18px;
        margin-left: 12px;
        position: absolute;
        top: calc(50% - 9px);
        left: 0;
      }
    }
  }
}
.or-wrapper {
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  flex-direction: column;
  .or {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    display: flex;
    flex-shrink: 0;
    align-items: stretch;
    .line {
      -webkit-box-flex: 1;
      flex-grow: 1;
      flex-shrink: 1;
      background-color: #dbdbdb;
      height: 1px;
      position: relative;
      top: 0.45rem;
    }
    .or-text {
      color: #8e8e8e;
      -webkit-box-flex: 0;
      flex-grow: 0;
      flex-shrink: 0;
      font-size: 13px;
      font-weight: 600;
      line-height: 15px;
      margin: 0 18px;
      text-transform: uppercase;
    }
  }
}
.email-login {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  flex-direction: column;
  .login-text {
    display: inline !important;
    margin: 0 !important;
    color: #262626;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    .login {
      font-weight: 600;
    }
    .signup {
      font-weight: 600;
    }
    a {
      border: 0;
      color: #0095f6;
      display: inline;
      padding: 0;
      position: relative;
      user-select: auto;
      cursor: pointer;
      font-weight: 600;
      text-align: center;
      text-overflow: ellipsis;
      width: auto;
      text-decoration: none;
    }
  }
}
</style>
